import { render, staticRenderFns } from "./PesquisarProduto.vue?vue&type=template&id=16fef216&scoped=true"
import script from "./PesquisarProduto.vue?vue&type=script&lang=js"
export * from "./PesquisarProduto.vue?vue&type=script&lang=js"
import style0 from "./PesquisarProduto.vue?vue&type=style&index=0&id=16fef216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fef216",
  null
  
)

export default component.exports